import {AbstractModel} from './abstract-model';

export class GoalType extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  identifier: string | null = null;
  goalIdentifier: string | null = null;

  override toString(): string {
    return this.name ?? '';
  }
}
